import React, { useMemo, useState } from "react";
import Button from "../../../../components/Button";
import BeneficiaryCard from "../components/BeneficiaryCard.jsx";
import beneficiaryModalStyles from "../css/BeneficiaryModal.module.css";

export default function BeneficiariesModal({
  showAddPatient,
  setShowAddPatient,
  beneficiaries,
  modalMode,
  viewReadOnly,
  mainHome,
  mainDelivery,
  handleAddBeneficiary,
  handleBeneficiaryChange,
  handleRemoveBeneficiary,
  handleSaveNewPatient,
  onToggleBeneficiaryEnabled,
  setModalStep,
}) {

  const [confirmIndex, setConfirmIndex] = useState(null);
  const [hiddenSet, setHiddenSet] = useState(() => new Set());
  const [confirmIsHidden, setConfirmIsHidden] = useState(false);
  if (!showAddPatient) return null;
  const totalCount = beneficiaries?.length ?? 0;
  const initialDisabled = new Set(
    (beneficiaries || []).map((b, i) => (b && b.enabled === false ? i : null)).filter((v) => v !== null)
  );
  const combinedHidden = new Set([...hiddenSet, ...initialDisabled]);
  const disabledCount = combinedHidden.size;
  const enabledCount = Math.max(0, totalCount - disabledCount);
  const displayCount = totalCount;

  const cardWidth = 320; 
  const gap = 16; 
  const horizontalPadding = 56;
  const count = Math.max(1, Math.min(displayCount || 1, 4));
  const contentPx = cardWidth * count + gap * (count - 1) + horizontalPadding + 24;
  const modalContentStyle = { width: `min(95vw, ${contentPx}px)` };
  const needScroll = totalCount > 4;
  return (
    <div className={beneficiaryModalStyles.modalPopup}>
      <div className={beneficiaryModalStyles.modalContent} style={modalContentStyle}>
        <div className={beneficiaryModalStyles.modalCard}>
          <div className={beneficiaryModalStyles.modalHeader}>
            <div className={beneficiaryModalStyles.titleRow}>
              <h2>{modalMode === "view" ? "Beneficiary List" : (modalMode === "update" ? "Update Beneficiaries" : "Add Beneficiaries")}</h2>
              {totalCount > 0 && (
                <span className={beneficiaryModalStyles.countText}>
                  {enabledCount}/{totalCount}
                </span>
              )}
            </div>

            <div className={beneficiaryModalStyles.headerActions}>
              {modalMode !== "view" && (
                <Button
                  variant="primary"
                  className={beneficiaryModalStyles.addBeneficiaryBtn}
                  onClick={handleAddBeneficiary}
                >
                  + Add Beneficiary
                </Button>
              )}

              <button
                type="button"
                className={beneficiaryModalStyles.closeX}
                aria-label="Close"
                onClick={() => {
                  if (typeof setShowAddPatient === "function") setShowAddPatient(false);
                  if (typeof setModalStep === "function") setModalStep(1);
                }}
              >
                ×
              </button>
            </div>
          </div>

          <div
            className={`${beneficiaryModalStyles.cardsGrid} ${needScroll ? beneficiaryModalStyles.cardsGridScrollable : beneficiaryModalStyles.cardsGridNoScroll}`}
          >
            {beneficiaries.map((b, i) => {
              const isHidden = combinedHidden.has(i);
              return (
                <BeneficiaryCard
                  key={i}
                  index={i}
                  value={b}
                  onChange={handleBeneficiaryChange}
                  onRemove={handleRemoveBeneficiary}
                  isUpdateMode={modalMode === "update"}
                  hideActions={modalMode === "view"}
                  isHidden={isHidden}

                  onRequestDisable={(idx) => { setConfirmIndex(idx); setConfirmIsHidden(false); }}
                  onRequestToggle={(idx, isHiddenNow) => { setConfirmIndex(idx); setConfirmIsHidden(isHiddenNow); }}
                  mainHome={mainHome}
                  mainDelivery={mainDelivery}
                />
              );
            })}
          </div>

          {confirmIndex !== null && (
            <div className={beneficiaryModalStyles.confirmOverlay}>
              <div className={beneficiaryModalStyles.confirmDialog}>
                <div className={beneficiaryModalStyles.confirmMessage}>
                  <span className={beneficiaryModalStyles.warnIcon}>!</span>
                  <span>
                    {confirmIsHidden
                      ? "Are you sure you want to enable this beneficiary"
                      : "Are you sure you want to disable this beneficiary"}
                  </span>
                </div>
                <div className={beneficiaryModalStyles.confirmActions}>
                  <Button
                    className={beneficiaryModalStyles.dangerBtn}
                    onClick={() => {
                      setHiddenSet((prev) => {
                        const next = new Set(prev);
                        const enabling = !!confirmIsHidden;
                        if (enabling) {
                          next.delete(confirmIndex);
                        } else {
                          next.add(confirmIndex);
                        }

                        if (typeof onToggleBeneficiaryEnabled === "function") {
                          onToggleBeneficiaryEnabled(confirmIndex, enabling);
                        }

                        return next;
                      });
                      setConfirmIndex(null);
                      setConfirmIsHidden(false);
                    }}
                  >
                    Yes
                  </Button>
                  <Button variant="secondary" onClick={() => setConfirmIndex(null)}>Cancel</Button>
                </div>
              </div>
            </div>
          )}

          {modalMode !== "view" && (
            <div className={beneficiaryModalStyles.modalFooter}>
              <Button
                variant="secondary"
                onClick={() => {
                  if (typeof setModalStep === "function") setModalStep(2);
                }}
              >
                Back
              </Button>
              <Button variant="primary" onClick={handleSaveNewPatient}>
                Save
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}